import React from 'react';
import TierThumbHtmlView from './TierHtml';
import TierThumbReactView from './Tier';
const TierThumbView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(TierThumbHtmlView, props);
    }
    return /*#__PURE__*/ React.createElement(TierThumbReactView, props);
};
TierThumbView.displayName = 'TierThumbView';
export default TierThumbView;
